import SimpleTableRow from './SimpleTableRow';

export default SimpleTableRow;
